// extracted by mini-css-extract-plugin
export default {"container":"Form5000properties_container__PEwnN","properties_title":"Form5000properties_properties_title__bCHEu"};